const Backbone = require('lib/backbone')
const BaseModel = require('lib/base_model')
const ProductList = require('./product_list')
const Storage = require('lib/localstorage')
const time = require('lib/time')
const log = require('log').create('cart model')  

const Cart = BaseModel.extend({

    storage_key: 'aboutme_cart_storage',
    storage_ttl: __DEBUG__ ? time.ONE_DAY : time.ONE_HOUR,

    defaults: {
        stripe_token: '',
        cust_id: '',
        coupon_code: '',
        purchased_from: '',
        items: [],
    },

    relations: [
        {
            type: Backbone.Many,
            key: 'items',
            collectionType: ProductList.extend({
                id: 'items',
            }),
        },
    ],

    initialize() {
        this.readStorage()
        this.listenTo(this, 'change nested-change add:items remove:items reset:items', this.writeStorage)
    },

    readStorage() {
        try {
            const attrs = Storage.get(this.storage_key, {})
            if (attrs) this.set(attrs)
        } catch (err) {
            log(err)
        }
    },

    writeStorage() {
        const attrs = this.toJSON()
        Storage.set(this.storage_key, attrs, { TTL: this.storage_ttl })
    },

    reset() {
        this.set(this.defaults)
    },

    flush() {
        Storage.deleteKey(this.storage_key)
    },

    calculated_values: {
        total() {
            const items = this.get('items').serialize()
            return items.reduce((subtotal, item) => {
                return subtotal + item.actual_price
            }, 0)
        },
        plan() {
            return this.get('items').findWhere({ type: 'plan' })
        },
        domain() {
            return this.get('items').findWhere({ type: 'domain' })
        },
        frequency() {
            if (this.get('plan')) {
                return this.get('plan').get('recurs')
            }

            return null
        },
        monthly_recurring_total() {
            if (this.get('frequency') === 'monthly') {
                return this.get('plan').get('actual_price')
            }

            return 0
        },
        yearly_recurring_total() {
            if (this.get('frequency') === 'yearly') {
                return this.get('total')
            }

            if (this.get('domain')) {
                return this.get('domain').get('actual_price')
            }

            return 0
        },
        payment_required() {
            // if total is > 0, payment is required
            return this.get('total') > 0
        },
    },

})

// proxy add/remove/findWhere methods
const proxy_methods = [
    'add',
    'remove',
    'findWhere',
]

proxy_methods.forEach((method) => {
    Cart.prototype[method] = function proxy() {
        const items = this.get('items')
        return items[method].apply(items, arguments)
    }
})

module.exports = Cart
